var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBreakerWeb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBreakerWeb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.72,0.24 C7.2,0.24 9.2,2.16 9.2,4.56 C9.2,5.68 8.8,6.72 8,7.52 C7.28,8.24 6.88,9.28 6.88,10.48 L6.88,12.24 C6.88,12.96 6.32,13.52 5.6,13.52 L3.92,13.52 C3.2,13.52 2.64,12.96 2.64,12.24 L2.64,10.48 C2.64,9.36 2.24,8.24 1.44,7.44 C0.56,6.48 0.16,5.28 0.32,4 C0.64,2 2.32,0.24 4.72,0.24 Z M6.24,12.24 L6.24,11.44 L3.36,11.44 L3.36,12.24 C3.36,12.56 3.6,12.88 4,12.88 L5.68,12.88 C6,12.8 6.24,12.56 6.24,12.24 Z M7.52,7.04 C8.16,6.4 8.56,5.52 8.56,4.56 C8.56,2.56 6.88,0.88 4.72,0.88 C2.72,0.88 1.2,2.4 0.96,4 C0.8,5.12 1.12,6.16 1.92,6.96 C2.8,7.92 3.28,9.12 3.28,10.4 L3.28,10.72 L6.24,10.72 L6.24,10.4 C6.24,9.12 6.72,7.92 7.52,7.04 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0.4,
    y: 0,
    width: 1,
    height: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.16 1.52 0.64 2 1.84 0.88 1.36 0.4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0.64,
    y: 0.08,
    width: 1.68,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-9",
    x: 0,
    y: 0.08,
    width: 1.68,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0.96 0.4 0.48 0.88 1.68 2 2.16 1.52"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icBreakerWeb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(3.200000, 2.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_1_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: -3.68,
    y: -3.76,
    width: 16.96,
    height: 21.28
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(7.200000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_3_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: -3.6,
    y: -4,
    width: 8.72,
    height: 9.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(12.000000, 1.600000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_5_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    fillRule: "nonzero",
    mask: "url(#mask-6)",
    x: -3.84,
    y: -3.6,
    width: 9.68,
    height: 9.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(13.600000, 7.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_7_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    fillRule: "nonzero",
    mask: "url(#mask-8)",
    x: -3.36,
    y: -3.92,
    width: 9.68,
    height: 8.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(0.000000, 7.200000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_9_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    fillRule: "nonzero",
    mask: "url(#mask-10)",
    x: -4,
    y: -3.92,
    width: 9.68,
    height: 8.64
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(1.600000, 1.600000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGID_11_"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#676767",
    fillRule: "nonzero",
    mask: "url(#mask-12)",
    x: -3.52,
    y: -3.6,
    width: 9.68,
    height: 9.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBreakerWeb);
export default __webpack_public_path__ + "static/media/icBreakerWeb.f289b45505b5383353921b1b747c3135.svg";
export { ForwardRef as ReactComponent };